const initialState = {
  zone: [],
};
export default initialState;
